// Api.js
import axios from 'axios';
import {API_BASE_URL} from '../FileUtils';

// Create an Axios instance with a base URL and common headers
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer YOUR_AUTH_TOKEN`, // Add authorization header here if applicable
    },
});

// You can also add request or response interceptors here if needed
// api.interceptors.request.use(config => {
//   // For example, add a token from localStorage before each request
//   const token = localStorage.getItem('authToken');
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

export default api;